/* eslint-disable */
import Swiper from 'swiper';
import { A11y, Keyboard, Navigation, Pagination } from 'swiper/modules';

export default function imageSlider() {
  const imageSliders = document.querySelectorAll('.image-slider');

  imageSliders.forEach((imageSlider) => {
    const slider = new Swiper(imageSlider, {
      modules: [A11y, Keyboard, Navigation, Pagination],
      loop: true,
      spaceBetween: 17,
      slidesPerView: 1,
      slideVisibleClass: '.swiper-slide-visible',
      keyboard: {
        enabled: true,
        pageUpDown: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        addIcons: false,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      a11y: {
        enabled: true,
        scrollOnFocus: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          slideVisibleClass: 'swiper-slide-visible',
        },
        1024: {
          slidesPerView: 3,
          slideVisibleClass: 'swiper-slide-visible',
        }
      },
      watchSlidesProgress: true,
      on: {
        slideChange: (swiper) => {
          swiper.slides.forEach((slide) => {
            if (slide.classList.contains('swiper-slide-visible')) {
              slide.removeAttribute('inert');
            } else {
              slide.setAttribute('inert', '');
            }
          });
        }
      }
    });
  });
}
